


<img src="../../../assets/images/check-green.gif">
<div class="align">
    <h2 style="color: rgb(3, 207, 3);">Refund Cancelled Successfully</h2>
</div>

<div class="buttonRow">
    <button mat-raised-button class="button" type="button" (click)="onNoClick()">
       Track your refund</button>
    <button mat-raised-button color="basic" class="buttonReset" type="button"(click)="onClick()" style="margin-left: 10px;">Close</button>
  </div>

